import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../context/CurrencyContext';
import { convert, formatMoney } from '../utils/fx';

// Renderiza un precio convertido a la divisa preferida del usuario.
// Mientras las tasas no carguen, muestra el monto en su divisa original.
// El atributo `title` siempre revela el precio canónico publicado.
export default function Price({ amount, currency, className, style, suffix }) {
  const { rates, displayCurrency } = useCurrency();
  const { t, i18n } = useTranslation();

  if (amount == null || !Number.isFinite(Number(amount))) return null;
  const from = currency || 'USD';
  const to = displayCurrency || from;
  const locale = i18n?.language;

  const original = formatMoney(amount, from, locale);
  const tooltip = t('currency.original_published_in', {
    defaultValue: 'Publicado en {{currency}} {{amount}}',
    currency: from,
    amount: Number(amount).toLocaleString(locale || undefined),
  });

  if (!rates || from === to) {
    return <span className={className} style={style} title={tooltip}>{original}{suffix || ''}</span>;
  }

  const converted = convert(amount, from, to, rates);
  return (
    <span className={className} style={style} title={tooltip}>
      {formatMoney(converted, to, locale)}{suffix || ''}
    </span>
  );
}
